import { useRef } from 'react';

export function useSwipe(onLeft: () => void, onRight: () => void, disabled = false, stopPropagation = false) {
  const start = useRef<{ x: number; y: number } | null>(null);
  return {
    onPointerDown: (event: React.PointerEvent) => {
      if (stopPropagation) event.stopPropagation();
      if (!disabled && event.pointerType !== 'mouse') start.current = { x: event.clientX, y: event.clientY };
    },
    onPointerUp: (event: React.PointerEvent) => {
      if (stopPropagation) event.stopPropagation();
      if (disabled || !start.current) return;
      const deltaX = event.clientX - start.current.x;
      const deltaY = event.clientY - start.current.y;
      start.current = null;
      if (Math.abs(deltaX) < 56 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
      if (deltaX < 0) onLeft(); else onRight();
    },
    onPointerCancel: (event: React.PointerEvent) => {
      if (stopPropagation) event.stopPropagation();
      start.current = null;
    },
  };
}
